import React from 'react';
import { Pagination } from '@mui/material';
import { formatDateTime } from '../../utils/dateTime';

const eventBadgeClass = (type = '') => {
  const t = type.toLowerCase();
  if (/open|click/.test(t)) return 'bg-info-100 text-info-600';
  if (/deliver/.test(t)) return 'bg-success-100 text-success-600';
  if (/bounce|reject|fail|drop|complaint|spam/.test(t)) return 'bg-danger-100 text-danger-600';
  return 'bg-neutral-200 text-secondary-light';
};

const EmailEventsTable = ({ events, loading, page, totalPages, onPageChange }) => {
  return (
    <div className="border rounded-4 p-20 mt-24">
      <h6 className="text-lg mb-16">Recent Email Events</h6>
      {/* Scroll box + sticky header so the columns stay readable while scanning
          events (same pattern as the Ads / Query / Expense tables). */}
      <div className="table-responsive" style={{ maxHeight: 'calc(100vh - 250px)', overflow: 'auto' }}>
        <table className="table bordered-table sm-table mb-0" style={{ position: 'relative' }}>
          <thead style={{ position: 'sticky', top: 0, zIndex: 10 }}>
            <tr style={{ background: '#f4f4f4', textAlign: 'left' }}>
              <th>#</th>
              <th>Recipient</th>
              <th>Subject / Template</th>
              <th>Campaign</th>
              <th className="text-center">Last Event</th>
              <th className="text-center">Delivered</th>
              <th>Sent At</th>
              <th>Last Event At</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="8" className="text-center py-3">
                  Loading…
                </td>
              </tr>
            ) : events?.length ? (
              events.map((e, i) => (
                <tr key={e._id ?? i}>
                  <td>{(page - 1) * (events.length || 1) + i + 1}</td>
                  <td>{e.recipient || '—'}</td>
                  <td>{e.template || '—'}</td>
                  <td>{e.campaign || 'unknown'}</td>
                  <td className="text-center">
                    <span
                      className={`badge text-sm fw-medium px-12 py-4 radius-4 ${eventBadgeClass(
                        e.last_event_type
                      )}`}
                    >
                      {e.last_event_type || 'Unknown'}
                    </span>
                  </td>
                  <td className="text-center">
                    <span
                      className={`badge text-sm fw-medium px-12 py-4 radius-4 ${
                        e.delivered ? 'bg-success-100 text-success-600' : 'bg-danger-100 text-danger-600'
                      }`}
                    >
                      {e.delivered ? 'Yes' : 'No'}
                    </span>
                  </td>
                  <td>{e.sent_at ? formatDateTime(e.sent_at) : '—'}</td>
                  <td>{e.last_event_at ? formatDateTime(e.last_event_at) : '—'}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="8" className="text-center py-3">
                  No email events found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {!loading && Boolean(totalPages) && totalPages > 1 && (
        <div className="d-flex justify-content-center mt-16">
          <Pagination
            count={totalPages}
            page={page}
            onChange={onPageChange}
            sx={{
              '& .MuiPaginationItem-root': { color: '#000', border: '1px solid #ddd' },
              '& .Mui-selected': { backgroundColor: '#ff4a4a !important', color: '#fff' },
              '& .MuiPaginationItem-root:hover': { backgroundColor: '#ffe5e5' },
            }}
          />
        </div>
      )}
    </div>
  );
};

export default EmailEventsTable;
